import {
  fillOrderSum,
  orderSumParam2Json,
  orderSumBindHandlers,
} from './ordersum.js';
export function mainordersum() {
  setTimeout(() => {
    console.log('test fill');
    orderSumBindHandlers();
    fillOrderSum({
      email: 'obornik@ctk.cz',
      name: 'Jan',
      company: 'soukroma osoba',
    });
    const data = orderSumParam2Json();
    console.log('data' + data);
    fillOrderSum(data);
  }, 3000);
}
